export default __webpack_public_path__ + "static/media/BuyplanRates.df434a46.png";